"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Publish = exports.SCROLL_TO_BUTTON_ID = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const react_redux_1 = require("react-redux");
const __1 = require("../../..");
const theme_1 = __importDefault(require("../../components/styles/theme"));
const Button_1 = require("../../components/button/Button");
const Paragraph_1 = require("../../components/paragraph/Paragraph");
const PublishModal_1 = require("../../components/publish-modal/PublishModal");
const Checkbox_1 = require("../../components/input/checkbox/Checkbox");
const Spacer_1 = require("../../components/spacer/Spacer");
const Section_1 = require("../../components/section/Section");
const Label_1 = require("../../components/input/label/Label");
const orange_svg_1 = __importDefault(require("../../../71eb904/assets/images/shapes/orange.svg"));
const green_svg_1 = __importDefault(require("../../../71eb904/assets/images/shapes/green.svg"));
const publish_ready_svg_1 = __importDefault(require("../../../71eb904/assets/images/illustrations/publish-ready.svg"));
const publish_not_ready_svg_1 = __importDefault(require("../../../71eb904/assets/images/illustrations/publish-not-ready.svg"));
const logging_1 = require("../../../logging");
const fact_1 = require("../../../entities/fact");
const capability_1 = require("../../../util/capability");
const types_1 = require("../../../types");
exports.SCROLL_TO_BUTTON_ID = 'ready-to-publish-button';
const Wrapper = styled_1.default.div `

	background-image: url(${({ readyToPublish }) => readyToPublish ? green_svg_1.default : orange_svg_1.default});
	background-size: auto 120%;
	background-repeat: no-repeat;
	background-position: 110%;

	display: flex;

	.publish-illustration {
		width: 25%;

		@media (max-width: 768px) {
			display: none;
		}

		display: flex;
		justify-content: center;
		align-items: center;
		overflow: hidden
	}

	img {
		min-width: 100%;
		max-height: 280px;
	}

	.publish-content {
		display: inline-block;

		@media (min-width: 768px) {
			padding-left: ${theme_1.default.layout.spacing.xLarge};
		}
	}

	.publish-check-label {
		max-width: 75%;

		@media (min-width: 768px) {
			max-width: 400px;
		}
	}

`;
const PublishNotReadyView = () => React.createElement(React.Fragment, null,
    React.createElement(Paragraph_1.Paragraph, null, "You're nearly done - fill in any remaining sections above."),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null, "Once everything is complete, you'll be able to publish your property ready for guests to see!"));
const PublishReadyView = () => React.createElement(React.Fragment, null,
    React.createElement(Paragraph_1.Paragraph, { id: "publish" }, "Great job! Each section is complete and your property is ready to publish."),
    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
    React.createElement(Paragraph_1.Paragraph, null, "Confirm that the information you have entered is accurate, then select 'publish.' Next, we'll take you through some final steps and get your property live."));
const Publish = ({ readyToPublish, customerId }) => {
    const [modalShowing, setModalShowing] = React.useState(false);
    const [canPublish, setCanPublish] = React.useState(false);
    const onPublishTap = () => setModalShowing(true);
    const closeModalAndScrollUp = () => {
        setModalShowing(false);
        window.scroll({ top: 0, behavior: 'smooth' });
    };
    const completeModal = () => {
        if (verifyOnPublish) {
            // Redirect to Portal 'Schedule Verification Call' action (uses `window.location.host` to support DEV and PROD)
            window.location.replace(`${window.location.protocol}//${window.location.host}`);
        }
        else {
            closeModalAndScrollUp();
        }
    };
    const { propertyId, entityActions, capabilities } = React.useContext(__1.AppContext);
    const { dispatch } = (0, react_redux_1.useStore)();
    const shortPublish = (0, capability_1.hasCapability)(capabilities, types_1.DashboardCapabilities.ShortPublish);
    const requirePropertyVerification = (0, capability_1.hasCapability)(capabilities, types_1.DashboardCapabilities.RequirePropertyVerification);
    const verifyOnPublish = (0, capability_1.hasCapability)(capabilities, types_1.DashboardCapabilities.VerifyOnPublish);
    const recordOnboardCompleteFact = (0, capability_1.hasCapability)(capabilities, types_1.DashboardCapabilities.RecordOnboardCompleteFact);
    const doPublish = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield dispatch(entityActions.property.publish(propertyId));
            if (customerId && recordOnboardCompleteFact) {
                const onboardCompletedFact = {
                    account: customerId,
                    type: fact_1.ONBOARD_COMPLETE_FACT,
                    context: { complete: true, propertyId }
                };
                yield dispatch(entityActions.facts.upsertForAccount(customerId, onboardCompletedFact));
            }
            return true;
        }
        catch (e) {
            logging_1.logging.error('Publish failed!', e);
            return false;
        }
    });
    const heading = readyToPublish ? 'You\'re now ready to publish' : 'You\'re almost ready to publish';
    return (React.createElement(Wrapper, { readyToPublish: readyToPublish },
        React.createElement("div", { className: "publish-illustration" },
            React.createElement("img", { src: readyToPublish ? publish_ready_svg_1.default : publish_not_ready_svg_1.default })),
        React.createElement("div", { className: "publish-content" },
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(Section_1.Section, { heading: heading },
                React.createElement(Spacer_1.Spacer, null),
                readyToPublish ? React.createElement(PublishReadyView, null) : React.createElement(PublishNotReadyView, null),
                React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                    React.createElement(Checkbox_1.Checkbox, { name: "temp-publish", onChange: () => setCanPublish(!canPublish), checked: canPublish, disabled: !readyToPublish }),
                    React.createElement("div", { style: { marginRight: '15px' } }),
                    React.createElement("div", { className: "publish-check-label" },
                        React.createElement(Label_1.Label, { htmlFor: "temp-publish" }, "I have reviewed all sections and am happy that the information provided is accurate."))),
                React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                React.createElement(Button_1.Button, { id: exports.SCROLL_TO_BUTTON_ID, buttonType: Button_1.PresetThemes.Primary, onClick: onPublishTap, disabled: !canPublish }, "I'm ready to publish"),
                modalShowing && React.createElement(PublishModal_1.PublishModal, { short: shortPublish, requirePropertyVerification: requirePropertyVerification, publish: doPublish, onClose: closeModalAndScrollUp, onComplete: completeModal })))));
};
exports.Publish = Publish;
//# sourceMappingURL=Publish.js.map